/**************************************************
 * Nombre:       Pagina
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Fab, Grid} from "@mui/material";
import Barra from "./Barra/Barra";
import Footer from "./Footer";
import Seccion_Home from "./Secciones/Seccion_Home";
import fondo from '../Recursos/fondo_pagina.svg'
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Seccion_Tours from "./Secciones/Seccion_Tours";
import Seccion_Nosotros from "./Secciones/Seccion_Nosotros";
import Seccion_Sostenibilidad from "./Secciones/Seccion_Sostenibilidad";
import Seccion_Detalle from "./Secciones/Seccion_Detalle";
import Seccion_Detalle_Sostenibilidad from "./Secciones/Seccion_Detalle_Sostenibilidad";
import Seccion_Adicional from "./Secciones/Seccion_Adicional";
import {useBotonWass} from "../Modulo_Boton_Wass/Hooks/useBotonWass";
import {WhatsApp} from '@mui/icons-material'
import Seccion_Pagos from "./Secciones/Seccion_Pagos";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";

const Pagina = () => {
    const {sCell} = useResponsive()
    const {Vista, abrir} = useBotonWass()


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `url(${fondo})`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right',
                backgroundSize: 'cover'
            }}
        >

            <Vista/>

            <Fab
                onClick={(e) => abrir(e.target)}
                sx={{
                    position: 'fixed',
                    bottom: sCell ? 20 : 40,
                    right: sCell ? 20 : 40,
                    width: 60,
                    height: 60,
                    backgroundColor: '#25D366',
                    '&:hover': {
                        backgroundColor: '#1fb456',
                    }
                }}
            >

                <WhatsApp sx={{width: 32, height: 32, fill: '#fff'}}/>
            </Fab>


            <Router>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 2}}>
                    <Barra/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                    <Routes>
                        <Route path={"*"} element={<Seccion_Home/>}/>
                        <Route path={"/"} element={<Seccion_Home/>}/>
                        <Route path={"/Home"} element={<Seccion_Home/>}/>
                        <Route path={"/Tours"} element={<Seccion_Tours/>}/>
                        <Route path={"/Tours/:id"} element={<Seccion_Tours/>}/>
                        <Route path={"/Nosotros"} element={<Seccion_Nosotros/>}/>
                        <Route path={"/Sostenibilidad"} element={<Seccion_Sostenibilidad/>}/>
                        <Route path={"/Detalle/:id"} element={<Seccion_Detalle/>}/>
                        <Route path={"/Detalle_Sos/:id"} element={<Seccion_Detalle_Sostenibilidad/>}/>
                        <Route path={"/Adicionales/:id"} element={<Seccion_Adicional/>}/>
                        <Route path={"/Pagos/:id"} element={<Seccion_Pagos/>}/>
                        <Route path={"/Pagos"} element={<Seccion_Pagos/>}/>
                    </Routes>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Footer/>
                </Grid>

            </Router>
        </Grid>
    )

}
export default Pagina    